import React, { useState } from "react";
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import style from "./Modal.module.scss";
import arrow from "../../assets/icons/arrow-white.svg";
import { TODIS_FORM_DSC, TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE } from "../Forms";
import { Formik, Form } from "formik";
import { RESEND, TODIS_RESEND } from "../../.config/resend";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";

const TODIS_MODAL_RESEND = ({onSubmit, ...props}) => {

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={style.todisModalContainer}
            className={style.todisModalContainer}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Formik
                            initialValues={TODIS_RESEND}
                            validationSchema={RESEND}
                            onSubmit={(values) => {
                                props.dataForm.remarks = values.remarks
                                onSubmit(props.dataForm)}}>
                            {({ errors, touched }) => (
                                <Form className="todis-form-content">
                                    <Row>
                                        <Col lg={12}>
                                            <TODIS_FORM_DSC id="remarks" label="CHANGES DONE" name="remarks"/>
                                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.remarks}</div>) : null}
                                        </Col>
                                    </Row>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}} type="submit">SUBMIT <BsArrowRight className="ms-2" size={20} /></Button>
                                    </div>
                                </Form>
                            )}
                    </Formik> 
                </Container>  
            </Modal.Body>
        </Modal>
    )
}

export { TODIS_MODAL_RESEND };